export const hasValidationErrors = (errors: Record<string, any>): boolean =>
  Object.values(errors).some(
    value => typeof value === 'string' && value.length > 0,
  );

export const passwordValidation = (password: string): string | boolean => {
  if (password.length < 8) {
    return 'Password not long enough';
  }
  return true;
};

export const testEmailAgainstRegex = (email: string): boolean => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
